import React, { useEffect, useState } from "react"
import { formatSeconds, getSecondsByHour } from "../../js/functions";

export function RegistroJornadaSemanal({ registroUser }) {

  const [tiempoTotalDia, setTiempoTotalDia] = useState(null);
  const [tiempoSemanaHorario, setTiempoSemanaHorario] = useState(null)

  useEffect(() => {
    setTiempoTotal()
    horasMinutosSemanales()
    // console.log(registroUser);
  }, []);

  function calcHorasSemanales(diaSemanaFor, trabajado) {
    if (trabajado === false) return 0

    // // Si pongo esto entonces solo cuentan los días que se fichó, es decir si mi horario es de 
    // // lunes a viernes, y estamos a jueves, y se ha fichado todos los días pero el viernes no, 
    // // entonces las horas totales no detectan el viernes por que "!trabajado" en cambio si 
    // // "trabajado === false" se detectan todos los días aunque no se haya iniciado sesión, en este caso el viernes
    // if (!trabajado) return 0

    const semana = registroUser.horarioSemanal

    if (semana[diaSemanaFor].inicio !== "") {
      if(semana[diaSemanaFor].dobleDia === true) {
        const arrIni = (semana[diaSemanaFor].inicio).split(":")
        const arrFin = (semana[diaSemanaFor].fin).split(":")
        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        return minutosFin + 1440 - minutosInicio
      }
      if(semana[diaSemanaFor].inicioTarde !== "") {
        const arrIni = (semana[diaSemanaFor].inicio).split(":")
        const arrFin = (semana[diaSemanaFor].fin).split(":")
        const arrIniTarde = (semana[diaSemanaFor].inicioTarde).split(":")
        const arrFinTarde = (semana[diaSemanaFor].finTarde).split(":")

        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        const minutosInicioTarde = parseInt(arrIniTarde[0]) * 60 + parseInt(arrIniTarde[1])
        const minutosFinTarde = parseInt(arrFinTarde[0]) * 60 + parseInt(arrFinTarde[1])
        return ((minutosFin - minutosInicio) + (minutosFinTarde - minutosInicioTarde));
      }
      else {
        const arrIni = (semana[diaSemanaFor].inicio).split(":")
        const arrFin = (semana[diaSemanaFor].fin).split(":")
        const minutosInicio = parseInt(arrIni[0]) * 60 + parseInt(arrIni[1])
        const minutosFin = parseInt(arrFin[0]) * 60 + parseInt(arrFin[1])
        return minutosFin - minutosInicio
      }
    } else return 0
  }

  function horasMinutosSemanales() {
    let minutosTotalesSemanales = 0;
    let horasSemanales = ""
    let minutosSemanales = ""

    // console.log(registroUser);
    for(let i=0; i<=6; i++) {
      let registro = ""
      if (i === 0) registro = registroUser.registroSemanal.domingo.trabajado
      else if (i === 1) registro = registroUser.registroSemanal.lunes.trabajado
      else if (i === 2) registro = registroUser.registroSemanal.martes.trabajado
      else if (i === 3) registro = registroUser.registroSemanal.miercoles.trabajado
      else if (i === 4) registro = registroUser.registroSemanal.jueves.trabajado
      else if (i === 5) registro = registroUser.registroSemanal.viernes.trabajado
      else if (i === 6) registro = registroUser.registroSemanal.sabado.trabajado
      minutosTotalesSemanales = calcHorasSemanales(i, registro) + minutosTotalesSemanales
    }
    
    if (minutosTotalesSemanales/60 < 10) {
      horasSemanales = `0${parseInt(minutosTotalesSemanales/60)}`
    }
    else {
      horasSemanales = `${parseInt(minutosTotalesSemanales/60)}`
    }
    if (minutosTotalesSemanales%60 < 10) {
      minutosSemanales = `0${parseInt(minutosTotalesSemanales%60)}`
    }
    else {
      minutosSemanales = `${parseInt(minutosTotalesSemanales%60)}`
    }

    setTiempoSemanaHorario(`${horasSemanales}:${minutosSemanales}`)
  }

  function setTiempoTotal() {
    const semana = [
      {registro: registroUser.registroSemanal.lunes},
      {registro: registroUser.registroSemanal.martes},
      {registro: registroUser.registroSemanal.miercoles},
      {registro: registroUser.registroSemanal.jueves},
      {registro: registroUser.registroSemanal.viernes},
      {registro: registroUser.registroSemanal.sabado},
      {registro: registroUser.registroSemanal.domingo}
    ]
    const tiempoTotalDiaAux = []
    let totalSegundosSemana = 0
    for (let i = 0; i<= 6; i++) {
      // if(semana[i].festivo === true) {
      //   tiempoTotalDiaAux[i] = "DIA FESTIVO"; 
      //   continue;
      // } 
      if(semana[i].registro === "" || semana[i].registro.trabajado === null) {
        tiempoTotalDiaAux[i] = ""
        continue; 
      } 
      if(semana[i].registro.trabajado === false) {
        tiempoTotalDiaAux[i] = semana[i].registro.motivoLibre; 
        continue;
      } 

      let pausas = "", totalSegundos = 0;
      if (semana[i].registro.pausas !== undefined && semana[i].registro.pausas !== null) {
        if (semana[i].registro !== "") {
          pausas = semana[i].registro.pausas.filter(pausa => pausa.tipo !== 2)
        }
        else {
          pausas = ""
        }
      } 

      if (pausas !== "" && pausas.length > 0 && semana[i].registro.fin !== undefined){
        for (let j = 0; j<pausas.length; j++) {
          if (pausas[j] !== undefined) {
            if (pausas[j].fin !== undefined){
              if (pausas.length === 1) { //solo si hay 1 pausa
                const segundosAux = pausas[0].inicio.seconds - semana[i].registro.inicio.seconds
                const segundosAux2 = semana[i].registro.fin.seconds - pausas[0].fin.seconds
                totalSegundos = segundosAux + segundosAux2

                tiempoTotalDiaAux[i] = formatSeconds(totalSegundos)
                totalSegundosSemana = totalSegundosSemana + totalSegundos
                continue;

                //console.log("una pausa")
              } else if (pausas.length === 2) { //hay 2 pausas
                const segundosAux = pausas[0].inicio.seconds - semana[i].registro.inicio.seconds
                const segundosAux2 = pausas[1].inicio.seconds - pausas[0].fin.seconds
                const segundosAux3 = semana[i].registro.fin.seconds - pausas[1].fin.seconds
                totalSegundos = segundosAux + segundosAux2 + segundosAux3

                tiempoTotalDiaAux[i] = formatSeconds(totalSegundos)
                totalSegundosSemana = totalSegundosSemana + totalSegundos
                continue;

                //console.log("2 pausas")
              } else { // hay mas de 2 pausas
                if (j === 0) { //primera pausa
                  const segundosAux = pausas[j].inicio.seconds - semana[i].registro.inicio.seconds
                  totalSegundos = totalSegundos + segundosAux
                  //console.log("tres pausas 1, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
                } else if (j < pausas.length) { //pausas intermedias
                  const segundosAux = pausas[j].inicio.seconds - pausas[j-1].fin.seconds
                  totalSegundos = totalSegundos + segundosAux
                  //console.log("tres pausas 2, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
                } 
                if(j === pausas.length-1) { //ultima pausa
                  const segundosAux = semana[i].registro.fin.seconds - pausas[j].fin.seconds
                  totalSegundos = totalSegundos + segundosAux
                  //console.log("tres pausas 3, segundos aux -> "+segundosAux+",    segundos totales -> "+totalSegundos)
                  tiempoTotalDiaAux[i] = formatSeconds(totalSegundos)
                  totalSegundosSemana = totalSegundosSemana + totalSegundos
                  continue;
                }
              }
            }
          }
        }
      }
      else if(semana[i].registro.fin !== undefined) {
        const totalSegundos = semana[i].registro.fin.seconds - semana[i].registro.inicio.seconds
        tiempoTotalDiaAux[i] = formatSeconds(totalSegundos)
        totalSegundosSemana = totalSegundosSemana + totalSegundos
        continue;
      }
      else {
        tiempoTotalDiaAux[i] = "DIA SIN COMPLETAR"
        continue;
      }
    }
    tiempoTotalDiaAux[7] = formatSeconds(totalSegundosSemana)
    setTiempoTotalDia(tiempoTotalDiaAux)
  }

  function addColors(tiempoTotalDia, registro) {
    if (tiempoTotalDia === "DIA SIN COMPLETAR") return <td style={{backgroundColor: "#dfa9a9", fontSize: "12px", paddingInline: "2px"}}>{tiempoTotalDia}</td>
    else if (registro !== "" && registro.trabajado === false && registro.motivoLibre === "OTROS") return <td style={{backgroundColor: "#e8a1ea", fontSize: "12px", paddingInline: "2px"}}>{registro.comentarioLibre}</td>
    else if (registro !== "" && registro.trabajado === false) return <td style={{backgroundColor: "#e8a1ea", fontSize: "12px", paddingInline: "2px"}}>{tiempoTotalDia}</td>
    else if (tiempoTotalDia === "") return <td>{tiempoTotalDia}</td>
    else return <td style={{backgroundColor: "#d1e6c6"}}>{tiempoTotalDia}</td>
  }

  function addColorsTotalHoras(tiempoRegistro, tiempoHorario) {
    if (getSecondsByHour(tiempoRegistro) < getSecondsByHour(tiempoHorario)) {
      return <td style={{backgroundColor: "#dfa9a9" }}>{tiempoRegistro} / {tiempoHorario}</td>
    }
    else {
      return <td style={{backgroundColor: "#d1e6c6" }}>{tiempoRegistro} / {tiempoHorario}</td>
    }
  }

  if (tiempoTotalDia !== null && tiempoSemanaHorario !== null) {
    return (
      <>
        {addColorsTotalHoras(tiempoTotalDia[7], tiempoSemanaHorario)}
        {addColors(tiempoTotalDia[0], registroUser.registroSemanal.lunes)}
        {addColors(tiempoTotalDia[1], registroUser.registroSemanal.martes)}
        {addColors(tiempoTotalDia[2], registroUser.registroSemanal.miercoles)}
        {addColors(tiempoTotalDia[3], registroUser.registroSemanal.jueves)}
        {addColors(tiempoTotalDia[4], registroUser.registroSemanal.viernes)}
        {addColors(tiempoTotalDia[5], registroUser.registroSemanal.sabado)}
        {addColors(tiempoTotalDia[6], registroUser.registroSemanal.domingo)}
      </>
    )
  }
  else return ""
}
